import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BadgeColorsEnum} from '../../../shared/interfaces/BadgeColorsEnum';
import {Select, Store} from '@ngxs/store';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ProfileState} from '../../../shared/states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';
import { IIntegrationConfiguration, IntegrationTypeEnum } from 'src/app/shared/interfaces/integration.interface';
// eslint-disable-next-line max-len
import { GetPharmacyManagementSystems, SetPharmacyManagementSystemIntegrationConnectionStatus } from 'src/app/shared/states/profile/profile.actions';
import { take } from 'rxjs/operators';
import { PmsStatusEnum } from '../../interfaces/PmsStatusEnum';

@UntilDestroy()
@Component({
  selector: 'app-pms-integration-table',
  templateUrl: './pms-integration-table.component.html',
  styleUrls: ['./pms-integration-table.component.scss'],
})
export class PharmacyManagementSystemIntegrationTableComponent implements OnInit {
  @Input() data: IIntegrationConfiguration[] = [];
  @Output() edit: EventEmitter<IIntegrationConfiguration> = new EventEmitter();
  @Output() activeChanged: EventEmitter<IIntegrationConfiguration> = new EventEmitter();
  @Input() showDeactivateIntegrationDialog = false;

  selectedIntegration: IIntegrationConfiguration;

  IntegrationTypeEnum = IntegrationTypeEnum;

  BadgeColorsEnum = BadgeColorsEnum;

  showRemovePharmacyManagementSystemDialog: boolean;

  PmsStatusEnum = PmsStatusEnum;

  displayCannotActivateMoreThanOnePmsAtATime: boolean;

  @Select(ProfileState.loading) loading$: Observable<boolean>;
  @Select(ProfileState.success) success$: Observable<boolean>;
  @Select(ProfileState.pharmacyManagementSystemIntegrations) pmsIntegrations$:
    Observable<IIntegrationConfiguration[]>;

  constructor(
    private store: Store,
  ) {
  }

  ngOnInit(): void {
    this.pmsIntegrations$
      .pipe(untilDestroyed(this))
      .subscribe((data: IIntegrationConfiguration[] = []) => {
        this.data = [...data];
      });
  }

  toggleSwitch(pms: IIntegrationConfiguration): void {
    if (!this.data.some(x => x.isActive && x?.id !== pms?.id)) {
      this.handleIsActiveChanged(pms);
    } else {
      this.displayCannotActivateMoreThanOnePmsAtATime = true;
    }
  }

  handleIsActiveChanged(pms: IIntegrationConfiguration): void {
    // if we're setting Active, open the Test page, otherwise, detached the webhook.
    this.selectedIntegration = pms;
    if (this.selectedIntegration.isActive) {
      this.selectedIntegration = pms;
      this.showDeactivateIntegrationDialog = true;
    } else {
      switch (pms.integrationType) {
        case IntegrationTypeEnum.PioneerRx:
        case IntegrationTypeEnum.FrameworkLTC:
          this.activateIntegration();
          break;
      
        default:
          this.activeChanged.emit(pms);
          break;
      }
    }
  }

  closeDeactivateIntegrationDialog(): void {
    this.showDeactivateIntegrationDialog = false;
  }

  activateIntegration(): void {
    this.store.dispatch(new SetPharmacyManagementSystemIntegrationConnectionStatus(this.selectedIntegration.id, true))
    .pipe(take(1))
    .subscribe(response => {
      this.store.dispatch(new GetPharmacyManagementSystems());
    });
  }

  deactivateIntegration(): void {
    this.store.dispatch(new SetPharmacyManagementSystemIntegrationConnectionStatus(this.selectedIntegration.id, false))
      .pipe(take(1))
      .subscribe(response => {
        this.store.dispatch(new GetPharmacyManagementSystems());
        this.closeDeactivateIntegrationDialog();
      });
  }
}
